 
import { AxiosError } from 'axios'

import { BaseQueryFn, createApi, FetchArgs } from '@reduxjs/toolkit/query/react'

import { OLMSApiService } from './OLMSApiService'

const axiosBaseQuery: BaseQueryFn<string | FetchArgs, unknown, unknown> = async (args, _api, _extraOptions) => {
  let result

  try {
    if (typeof args === 'string') {
      result = await OLMSApiService.get<unknown>(args)
    } else {
      const { url, method, body, params } = args

       
      switch (method?.toUpperCase()) {
        case 'GET':
          result = await OLMSApiService.get<unknown>(url, params)
          break
        case 'POST':
          result = await OLMSApiService.post<unknown>(url, body)
          break
        default:
          throw new Error('Method not supported')
      }
    }

    return { data: result }
  } catch (axiosError) {
    const err = axiosError as AxiosError

    return {
      error: {
        status: err.response?.status || 500,
        data: err.response?.data || err.message,
      },
    }
  }
}

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery,
  endpoints: () => ({}),
})
